<section>
  <div class="content">
    <div class="bluescreen">
    </div>
    <div class="background-content">
      <div class="logo-wrapper slide">
        <!-- <img id="animated-logo" class="logo" src="assets/img/header/Logo.png" alt="Logo Join"> -->
      </div>
      <div class="login-nav">
        <p>Not a Join User?</p>
        <button class="register-button" routerLink="/signup">Sign up</button>
      </div>
    </div>
    <div class="login-container">
      <div class="login-overlay">
        <div class="login-title">
          <h1>Log in</h1>
          <div class="title-line"></div>
        </div>
        <div class="login-form">
          <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <!-- Email-Feld -->
            <div class="input-wrapper">
              <input class="mail-icon" maxlength="30" type="email" placeholder="Email" formControlName="email"
                [class.error-border]="form.get('email')?.invalid && (form.get('email')?.dirty || form.get('email')?.touched) || errorMessage"
                type="email">
            </div>
            <!-- Passwort-Feld mit Bild-Logik -->
            <div class="input-wrapper">
              <input #pwInput class="lock-icon" maxlength="30" [type]="showPassword ? 'text' : 'password'" placeholder="Password"
                formControlName="password" (focus)="isFocused = true" (blur)="isFocused = false"
                (input)="checkPasswordInput()"
                [class.error-border]="(form.get('password')?.invalid && (form.get('password')?.dirty || form.get('password')?.touched)) || errorMessage">
              <img [src]="lockIconSrc" alt="Lock Icon" class="lock-image" (click)="checkLockClick(pwInput)">
            </div>
            <!-- Fehlertext -->

            <div class="error-text">
              @if (errorMessage != null) {
                <p>{{ errorMessage }}</p>
              }
              <!--               @if (this.form.invalid && this.form.touched) {

              <p>Check your email and password.</p>
              }
 -->
            </div>
            <!-- Buttons -->
            <div class="form-btn">
              <button type="submit" class="login-button">Login</button>
              <button (click)="guestLogIn()" type="button" class="guest-button" routerLink="/">Guest Log in</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="login-nav-mobile">
      <p>Not a Join User?</p>
      <button class="register-btn-mobile" routerLink="/signup">Sign up</button>
    </div>
    <footer>
      <div class="footer-content">
        <a [routerLink]="'/privacy-sign-in'">Privacy Policy</a>
        <a [routerLink]="'/legal-notice-sign-in'">Legal notice</a>
      </div>
    </footer>
  </div>
</section>